import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M10.5 17H8C5.23858 17 3 14.7614 3 12C3 9.23858 5.23858 7 8 7H11M8.5 19.5L10.5 17L8.5 14.5M13.5 12H17.1143M21.5 12H20M13.5 7H19.4M13.5 17H14.8286M21.5 17H18M13 21L14.8286 17M21 3.5L19.4 7M19.4 7L17.1143 12M17.1143 12L14.8286 17" />
	</SVG>
);
